import Vue from 'vue';
import Vuex from 'vuex';
import {
  loginByPassword,
  loginByPhone,
  validateCode,
  getLoginUser,
  logout,
  delOrgFavorite,
  delProductFavorite, delRequireFavorite, delKnowFavorite,
} from 'service/api';
import router from 'src/router';

Vue.use(Vuex);

const list: string[] = [];

const routeToDelApi = {
  orgFavor: delOrgFavorite,
  productFavor: delProductFavorite,
  requireFavor: delRequireFavorite,
  knowledgeFavor: delKnowFavorite,
};

type RouteName = 'orgFavor' | 'productFavor' | 'requireFavor' | 'knowledgeFavor';

interface FavorRes {
  code: number;
  msg: string;
}

interface LoginResponse {
  code: number;
  data: {
    rows: any
  }
}

export default new Vuex.Store({
  state: {
    // 用户信息
    user: {
      userName: '',
      avatar: '',
      userId: '',
      enterpriseId: '',
      organizationId: '',
      platformId: '',
    },
    // 收藏是否处于操作中
    isInOperation: false,
    // 选中的收藏信息id列表
    selectedFavorIdList: list,
    // 缓存列表是否应该刷新
    shouldRefresh: false,
  },
  mutations: {
    SET_USER: (state, userInfo) => {
      state.user = userInfo;
    },
    SET_OPERATION: (state, inOp) => {
      state.isInOperation = inOp;
    },
    SET_LIST: (state, idList: string[] | string) => {
      if (Array.isArray(idList)) {
        state.selectedFavorIdList = idList;
      } else {
        const index = state.selectedFavorIdList.indexOf(idList);
        if (index === -1) {
          state.selectedFavorIdList.push(idList);
        } else {
          state.selectedFavorIdList.splice(index, 1);
        }
      }
    },
    SET_REFRESH: (state, shouldRefresh) => {
      state.shouldRefresh = shouldRefresh;
    },
  },
  actions: {
    Login({ commit }, param) {
      return new Promise((resolve, reject) => {
        loginByPassword(param).then((res) => {
          if ((res as LoginResponse).code === 200) {
            const data = (res as LoginResponse).data.rows;
            commit('SET_USER', {
              userName: data.userName,
              avatar: data.avatar,
              userId: data.id,
              enterpriseId: data.enterpriseId,
              organizationId: data.organizationId,
              platformId: data.platformId,
            });
            resolve();
          } else {
            throw new Error((res as { msg: string }).msg);
          }
        }).catch((error) => {
          Vue.prototype.$notify.error(error.message);
          reject(error);
        });
      });
    },

    LoginByPhone({ commit }, param) {
      return new Promise((resolve, reject) => {
        validateCode({
          phonenumber: param.phone,
          singleSendercode: param.code,
          codeType: 1,
        }).then((res) => {
          if ((res as { code: number }).code === 200) {
            return loginByPhone({
              phonenumber: param.phone,
              singleSendercode: param.code,
            });
          }
          throw new Error((res as { msg: string }).msg);
        }).then((res) => {
          if ((res as LoginResponse).code === 200) {
            const data = (res as LoginResponse).data.rows;
            commit('SET_USER', {
              userName: data.userName,
              avatar: data.avatar,
              userId: data.id,
              enterpriseId: data.enterpriseId,
              organizationId: data.organizationId,
              platformId: data.platformId,
            });
            resolve();
          } else {
            throw new Error((res as { msg: string; }).msg);
          }
        }).catch((error) => {
          Vue.prototype.$notify.error(error.msg);
          reject(error);
        });
      });
    },

    GetUserDetail({ commit }) {
      return new Promise((resolve, reject) => {
        getLoginUser().then((res: any) => {
          if ((res as LoginResponse).code === 200) {
            const { data: { rows: data } } = res;
            commit('SET_USER', {
              userName: data.userName,
              avatar: data.avatar,
              userId: data.id,
              enterpriseId: data.enterpriseId,
              organizationId: data.organizationId,
              platformId: data.platformId,
            });
          }
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    Logout({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_USER', {
            userName: '',
            avatar: '',
            userId: '',
            enterpriseId: '',
            organizationId: '',
            platformId: '',
          });
          resolve();
        }).catch((error) => {
          reject(error);
        });
      });
    },

    CancelFavorite(t, param) {
      return new Promise((resolve, reject) => {
        routeToDelApi[(router.currentRoute.name as RouteName)](param.id).then((res) => {
          if ((res as FavorRes).code === 200) {
            resolve();
          } else {
            Vue.prototype.$notify.error((res as FavorRes).msg);
            reject();
          }
        });
      });
    },
  },
});
